// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1_KMT","imageUploader":"EGiftCard_imageUploader__3hVkD"};